export const getSticksWithAggregationsMap = (sticksData) => {
    const flavourCodeToProductMap = aggregateSticksVariantsByFlavourCode(sticksData);
    const [mix_n_match_onetime] = sticksData.mix_n_match.onetime;
    const [mix_n_match_subscription] = sticksData.mix_n_match.subscription;
    const sticksMap = new Map();
    flavourCodeToProductMap.forEach((value) => {
        const { single_packs, cartons: carton_onetime } = value.onetime;
        const { cartons: carton_subscription } = value.subscription;
        if (single_packs) {
            sticksMap.set(single_packs.sku, {
                current: { ...single_packs, orderFrequency: "onetime", packagingPreference: "single_packs" },
                aggregations: {
                    onetime: { cartons: carton_onetime, mix_n_match: mix_n_match_onetime },
                    subscription: { cartons: carton_subscription, mix_n_match: mix_n_match_subscription },
                },
            });
        }
        if (carton_onetime) {
            sticksMap.set(carton_onetime.sku, {
                current: { ...carton_onetime, orderFrequency: "onetime", packagingPreference: "cartons" },
                aggregations: {
                    onetime: { single_packs, mix_n_match: mix_n_match_onetime },
                    subscription: { cartons: carton_subscription, mix_n_match: mix_n_match_subscription },
                },
            });
        }
        if (carton_subscription) {
            sticksMap.set(carton_subscription.sku, {
                current: { ...carton_subscription, orderFrequency: "subscription", packagingPreference: "cartons" },
                aggregations: {
                    onetime: { single_packs, cartons: carton_onetime, mix_n_match: mix_n_match_onetime },
                    subscription: { mix_n_match: mix_n_match_subscription },
                },
            });
        }
    });
    const defaultCartonOnetime = sticksData.cartons.onetime[0];
    const defaultCartonSubscription = sticksData.cartons.subscription[0];
    const defaultSinglePackOnetime = sticksData.single_packs.onetime[0];
    const mix_n_match_aggregations = {
        onetime: {
            single_packs: defaultSinglePackOnetime,
            cartons: defaultCartonOnetime,
            mix_n_match: mix_n_match_onetime,
        },
        subscription: { cartons: defaultCartonSubscription, mix_n_match: mix_n_match_subscription },
    };
    if (mix_n_match_onetime) {
        sticksMap.set(mix_n_match_onetime.sku, {
            current: { ...mix_n_match_onetime, orderFrequency: "onetime", packagingPreference: "mix_n_match" },
            aggregations: mix_n_match_aggregations,
        });
    }
    if (mix_n_match_subscription) {
        sticksMap.set(mix_n_match_subscription.sku, {
            current: { ...mix_n_match_subscription, orderFrequency: "subscription", packagingPreference: "mix_n_match" },
            aggregations: mix_n_match_aggregations,
        });
    }
    return sticksMap;
};
function aggregateSticksVariantsByFlavourCode(sticksData) {
    const flavourCodeToProductMap = new Map();
    sticksData.single_packs.onetime.forEach((x) => {
        flavourCodeToProductMap.set(String(x.flavour), { onetime: { single_packs: x }, subscription: {} });
    });
    sticksData.cartons.onetime.forEach((x) => {
        const previouslyAssigned = flavourCodeToProductMap.get(String(x.flavour));
        if (!previouslyAssigned)
            return;
        previouslyAssigned.onetime.cartons = x;
    });
    sticksData.cartons.subscription.forEach((x) => {
        const previouslyAssigned = flavourCodeToProductMap.get(String(x.flavour));
        if (!previouslyAssigned)
            return;
        previouslyAssigned.subscription.cartons = x;
    });
    return flavourCodeToProductMap;
}
//# sourceMappingURL=getSticksWithAggregationsMap.js.map